import * as Actions from './actions.js'

export const initialState = {
  error: false,
  loading: true,
  questionnaireResponse: {
    goals: []
  }
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.GOALS:
      return {
        ...initialState,
        loading: true
      }
    case Actions.GOALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        questionnaireResponse: action.questionnaireResponse
      }
    case Actions.GOALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        questionnaireResponse: { ...initialState.questionnaireResponse }
      }
    default:
      return state
  }
}
